"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberWithCommas = void 0;
/**
 * Summary:
 *     Format numbers in the text with commas as a thousand separators.
 */
var numberWithCommas = function (text) {
    return (text === null || text === void 0 ? void 0 : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) || "";
};
exports.numberWithCommas = numberWithCommas;
//# sourceMappingURL=number-helper.js.map